if (!customElements.get('hoculus-cart-checkboxes')) {
    class HoculusCartCheckboxes extends HTMLElement {
        constructor() {
            super();
            this.sectionId = this.dataset.sectionId;
            this.selectAllInput = this.querySelector(`#select-all-${this.sectionId}`);
            this.checkboxArray = this.querySelectorAll("input.obbligatory-check");
        }

        connectedCallback() {
            for (const checkbox of this.checkboxArray) {
                checkbox.addEventListener("change", () => this.updateButton());
            }
            this.selectAllInput.addEventListener('change', this.selectAllCheckboxes.bind(this));
        }

        updateButton() {
            this.cartButton = document.querySelector('button#hoculus-cart-drawer-checkout-btn');
            if (this.querySelectorAll("input.obbligatory-check:checked").length === this.checkboxArray.length) {
                this.cartButton.disabled = false;
            } else {
                this.cartButton.disabled = true;
            }
        }

        selectAllCheckboxes(evt) {
            this.checkboxArray.forEach(checkbox => {
                checkbox.checked = evt.target.checked;
            })   

            this.updateButton();
        }
    }
    customElements.define("hoculus-cart-checkboxes", HoculusCartCheckboxes);
}